<template lang="html">
  <layout>
    <v-container grid-list-xl>
      <v-layout row wrap>
        <v-toolbar flat color="rgba(0,0,0,0)" prominent>
          <h1>Remodeler Profile</h1>
          <v-spacer></v-spacer>
          <v-select
            :items="managerList"
            v-model="remodeler.manager_email"
            @change="assignManager"
            label="Manager"/>
          <v-spacer></v-spacer>
          <v-select
            :items="['APPROVED','DENIED']"
            v-model="remodeler.approval_status"
            @change="approvalAction()"
            label="Status"/>
          <v-spacer></v-spacer>
          <h3>{{remodeler.name}} {{remodeler.bbb_rating}}</h3>
        </v-toolbar>
        <v-divider />
        <v-flex md6>
          <v-layout row wrap>
            <v-flex xs12>
              <v-card>
                <v-card-title primary-title>
                  <span class="headline">Details</span>
                </v-card-title>
                <v-card-text>
                  <v-text-field
                    name="name"
                    label="name"
                    v-model="remodeler.name"
                    disabled
                    single-line/>
                  <v-text-area
                    name="description"
                    label="description"
                    disabled
                    v-model="remodeler.description"/>
                  <v-flex v-if="remodeler.locations[0].phone_number">
                    Phone: {{ remodeler.locations[0].phone_number }}
                  </v-flex>
                  <v-flex v-if="remodeler.email">
                    Email: {{ remodeler.email}}
                  </v-flex>
                  <v-flex v-if="remodeler.first_name">
                    Name: {{remodeler.first_name}} {{remodeler.last_name}}
                  </v-flex>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12>
              <v-card>
                <v-card-title primary-title>
                  <span class="headline">Survey</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <v-layout row wrap>
                    <v-flex md12>
                      <v-checkbox
                        label="I have Installed Fiber Cement Sidings"
                        v-model="remodeler.has_already_installed_fiber_cement_sidings" :value="remodeler.has_already_installed_fiber_cement_sidings"
                        disabled
                        color="primary" />
                      <v-checkbox
                        label="I am a part of another Siding Rewards Program"
                        v-model="remodeler.is_already_part_of_another_siding_rewards_program"
                        :value="remodeler.is_already_part_of_another_siding_rewards_program"
                        disabled
                        color="primary" />
                      <v-text-field
                        name="name"
                        label="Name of Other Siding Program"
                        v-model="remodeler.other_siding_reward_program"
                        disabled
                        v-if="remodeler.is_already_part_of_another_siding_rewards_program"
                        single-line />
                      <v-checkbox
                        label="I subcontract my installation"
                        v-model="remodeler.does_subcontract_installation"
                        :value="remodeler.does_subcontract_installation"
                        disabled
                        color="primary" />
                      <v-checkbox
                        label="I have a showroom"
                        v-model="remodeler.has_showroom"
                        :value="remodeler.has_showroom"
                        disabled
                        color="primary" />
                      <v-checkbox
                        label="I am Bonded and Insured"
                        v-model="remodeler.is_bonded_and_insured"
                        :value="remodeler.is_bonded_and_insured"
                        disabled
                        color="primary" />
                      <v-checkbox
                        label="I am insured for at least 1 million dollars"
                        v-model="remodeler.is_insured_for_at_least_1_million_dollars"
                        :value="remodeler.is_insured_for_at_least_1_million_dollars"
                        disabled
                        color="primary" />
                      <v-text-field
                        name="name"
                        label="How many sales people?"
                        v-model="remodeler.number_of_sales_people"
                        disabled
                        single-line />
                      <v-text-field
                        name="name"
                        label="Who supplies my siding?"
                        v-model="remodeler.siding_suppliers"
                        disabled
                        single-line />
                      <v-select
                        :items="['Less than a year', '1-3 years', '4-7 years', 'over 7 years']"
                        box
                        label="Years in Business"
                        disabled
                        v-model="remodeler.years_in_business" />
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex md6>
          <v-layout column wrap>
            <v-flex>
              <v-card>
                <v-card-title primary-title>
                  <span class="headline">Locations</span>
                </v-card-title>
                <v-card-text>
                  <v-data-table
                    :headers="locationHeaders"
                    :items="remodeler.locations"
                    hide-actions
                    class="elevation-0">
                    <template v-slot:items="props">
                      <td>{{ props.item.address }}</td>
                      <td>{{ props.item.city }}</td>
                      <td>{{ props.item.city }}</td>
                      <td>{{ props.item.zip_code}}</td>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex>
              <v-card>
                <v-card-title primary-title>
                  <span class="headline">Jobs</span>
                </v-card-title>
                <v-card-text>
                  <jobs-table :remodelerJobs="remodeler.jobs" />
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </layout>
</template>

<script>
import Layout from '@/shared/Layout'
import jobsTable from '../Jobs/_table'
import _ from 'lodash'
export default {
  data () {
    return {
      remodeler: '',
      confirm: false,
      changeCount: 0,
      remodelerId: this.$auth.userId || this.$route.params.id,
      managers: [],
      locationHeaders: [
        {
          text: 'Address'
        },
        {
          text: 'City'
        },
        {
          text: 'State'
        },
        {
          text: 'Zip'
        }
      ]
    }
  },
  computed: {
    managerList () {
      return _.map(this.managers, 'email')
    }
  },
  components: {
    Layout,
    jobsTable
  },
  methods: {
    addLocation () {
      let location = this.newLocation
      this.$http({
        method: 'post',
        url: '/remodeler/locations',
        data: location
      }).then((response) => {
        this.locations.push(location)
        this.locationModal = false
      })
    },
    listUsers () {
      console.log('list users')
      this.$http({
        method: 'GET',
        url: '/admin/managers'
      }).then((res) => {
        this.managers = res.data
      })
    },
    assignManager () {
      this.$http({
        method: 'put',
        url: 'admin/remodelers/' + this.$route.params.id + '/manager',
        data: {
          manager_email: this.remodeler.manager_email
        }
      }).then((response) => {
        console.log(response)
      })
    },
    approvalAction () {
      if (this.remodeler.approval_status === 'APPROVED') {
        this.$http({
          method: 'put',
          url: '/admin/remodelers/' + this.$route.params.id,
          data: {
            approval_action: 'DO_APPROVE'
          }
        }).then((response) => {
          this.$router.push('/admin/remodelers')
        })
      } else {
        this.$http({
          method: 'put',
          url: '/admin/remodelers/' + this.$route.params.id,
          data: {
            approval_action: 'DO_DENY'
          }
        }).then((response) => {
          this.$router.push('/admin/remodelers')
        })
      }
    },
    saveProfile () {
      this.$http({
        method: 'put',
        url: '/admin/remodelers/' + this.$route.params.id,
        data: this.remodeler
      }).then((response) => {
        this.changeCount = 0
      })
    },
    confirmLeave () {
      this.changeCount = 0
      this.$router.next()
    }
  },
  watch: {
    remodeler: {
      handler: function (newValue) {
        this.changeCount++
      },
      deep: true
    }
  },
  mounted () {
    this.$http({
      method: 'get',
      url: '/admin/remodelers/' + this.remodelerId
    }).then((response) => {
      this.remodeler = response.data
    })
    this.changeCount = -1
    this.listUsers()
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/Remodelers/Profile.vue